import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelpModalComponent } from './help-modal/help-modal.component';
import { InsuranceService } from './shared/services/insurance.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnDestroy {
  title = 'inspecao-digital-frontend';
  insuranceTitle: string = '';
  _urlImage: string = '';

  imgUrl: string = '../assets/images/logos';
  imageToShow: any;
  isImageLoading: boolean;

  public href: string = "";

  private iconTranslateObserver: MutationObserver | null = null;

  constructor(private dialog: MatDialog, private _insuranceService: InsuranceService, private router : Router){
    console.log("v20220106.1100")
    this._insuranceService.getLogo('chubb').subscribe(url => {
      if(url) {
        this._urlImage = url;
      }
    });

    // this.getLogoFromFolder('chubb');

    this.getImageFromService();
    
  }

  /**
   * Método para trazer imagens do serviço que pega de uma url
   */
  // getLogoFromFolder(type: string) {
  //   let reader = new FileReader();
  //   this._insuranceService.getLogoUrl(type).subscribe(data => {
  //     // reader.addEventListener(("load"), () => {
  //     //   // variavel para pegar o src
  //     //   console.log(reader.result);
  //     // }, false);
  //     if (data) {
  //       reader.readAsDataURL(data);
  //     }
  //   },
  //   error => {
  //     // tratamento de erro
  //   });
  // }

  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
       this.imageToShow = reader.result;
    }, false);
 
    if (image) {
       reader.readAsDataURL(image);
    }
   }
 
   getImageFromService() {
       this.isImageLoading = true;
       this._insuranceService.getImage(this.imgUrl).subscribe(data => {
         this.createImageFromBlob(data);
         this.isImageLoading = false;
       }, error => {
         this.isImageLoading = false;
         console.log(error);
       });
   }

  openModal(){
    const dialogRef = this.dialog.open(HelpModalComponent, {
      width: '40%',
      height: '70%'
    });
  }

  /**
   * HUB-1614: a traducao automatica do navegador (Google Tradutor / Chrome) reescreve
   * o texto das ligaduras do Material Icons (ex: "search" -> "Pesquisar", "menu" ->
   * "Cardapio", "help" -> "Ajuda"), quebrando os icones (viram letras/somem). Marcar
   * cada elemento .material-icons como translate="no" mantem os icones intactos mesmo
   * quando a pagina e traduzida — inclusive por traducao manual ou extensoes. O
   * MutationObserver cobre tambem os icones adicionados dinamicamente (menu, modais,
   * listas) depois do carregamento inicial.
   */
  ngAfterViewInit(): void {
    this.protectMaterialIcons(document.body);
    this.iconTranslateObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node instanceof HTMLElement) {
            this.protectMaterialIcons(node);
          }
        });
      });
    });
    this.iconTranslateObserver.observe(document.body, { childList: true, subtree: true });
  }

  ngOnDestroy(): void {
    if (this.iconTranslateObserver) {
      this.iconTranslateObserver.disconnect();
    }
  }

  private protectMaterialIcons(root: HTMLElement): void {
    // Cobre material-icons e todas as variantes de ligadura por substring:
    // material-icon (singular), material-icons-outlined/-round/-sharp/-two-tone.
    const selector = '[class*="material-icon"]';
    if (root.matches && root.matches(selector)) {
      root.setAttribute('translate', 'no');
    }
    root.querySelectorAll(selector).forEach(el => el.setAttribute('translate', 'no'));
  }
}
